import React, {useState} from 'react';
import images from '../images';
import {useAuth} from '../context/AuthContext';
import MobileLoginForm from "../components/Forms/MobileLoginForm";
import {useNavigate} from 'react-router-dom';

const MobileLogin = () => {
  const { login: loginMethod } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [termsCheck, setTermsCheck] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Пожалуйста, введите логин и пароль');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Вызываем метод авторизации
      const success = await loginMethod(email, password);

      // Сохраняем данные пользователя в сессию (в реальности можно использовать localStorage)
      // Для заглушки просто передаем дальше
      if (success) {
        navigate('/');
      }
      // Перенаправляем на главную страницу после успешного входа
    } catch (err) {
      // Ошибка уже будет показана в Toast через apiRequest
    } finally {
      setLoading(false);
    }
  };


  return (
    <div  style={{backgroundImage: `url(${images.loginBackground})` }} className="mobile-login-container">
        <div className="mobile-login-content">

          <MobileLoginForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            loading={loading}
            error={error}
            handleSubmit={handleSubmit}
            termsCheck={termsCheck}
            setTermsCheck={setTermsCheck}
          />

        </div>
    </div>
  );
};

export default MobileLogin;